import { configureStore } from '@reduxjs/toolkit'
import menuReducer from '../features/menu.slice'

export default configureStore({
  reducer: {
    menu: menuReducer,
  },
})
